//
// DO NOT EDIT this file directly.  Changes will be lost.
// Changes to static-data.json will be reflected here.
//
// This file is generated by apps/build/scripts/static-data/gen-static-data.mjs
//


import { Injectable } from "@angular/core";
import { DatasetId, DatasetCategoryId, DisplayTypeId, PublishAreaId } from "../interfaces/static-enums";


interface Datum<ID> {
	id: ID,
	name: string,
}

export interface Dataset extends Datum<DatasetId> {
	datasetCategoryId: number,
}

export interface DatasetCategory extends Datum<DatasetCategoryId> {
	sortOrder: number,
}

export interface DisplayType extends Datum<DisplayTypeId> {
	category: string,
	icon: string,
}

export interface PublishArea extends Datum<PublishAreaId> {
}


class StaticData<ID, DATUM extends Datum<ID>> {

	private _byId: Map<ID, DATUM>;

	constructor(private data: DATUM[]) {
		this._byId = new Map<ID, Readonly<DATUM>>(this.data.map(obj => [obj.id, obj]));
	}

	public byId(id: ID): Readonly<DATUM>;
	public byId(id: undefined): undefined;
	public byId(id: ID | undefined): Readonly<DATUM> | undefined {
		if (id == undefined) return undefined;
		return this._byId.get(id);
	}

	/** Returns all items sorted per the sortColumn in the static-data.json file */
	public get all(): Readonly<DATUM[]> {
		return this.data;
	}
}

/**
 * To change the StaticDataService, adjust static-data.json and rerun the generator.
 */
@Injectable({ providedIn: 'root' })
export class StaticDataService {

	public readonly datasets = new StaticData<DatasetId, Dataset>([
		{ id: DatasetId.AiAdvisor, name: 'AI Advisor', datasetCategoryId: 4 },
	]);

	public readonly dataset_categorys = new StaticData<DatasetCategoryId, DatasetCategory>([
		{ id: DatasetCategoryId.CrossFunctional, name: 'Cross-Functional', sortOrder: 1 },
		{ id: DatasetCategoryId.Development, name: 'Development', sortOrder: 2 },
		{ id: DatasetCategoryId.Knowledge, name: 'Knowledge', sortOrder: 3 },
		{ id: DatasetCategoryId.Programs, name: 'Programs', sortOrder: 4 },
		{ id: DatasetCategoryId.Staff, name: 'Staff', sortOrder: 5 },
		{ id: DatasetCategoryId.Dashboards, name: 'Dashboards', sortOrder: 6 },
	]);

	public readonly display_types = new StaticData<DisplayTypeId, DisplayType>([
		{ id: DisplayTypeId.PivotTable, name: 'Pivot Table', category: "Tables", icon: "fa-table-pivot" },
		{ id: DisplayTypeId.Report, name: 'Report', category: "Tables", icon: "fa-table" },
		{ id: DisplayTypeId.SankeyChart, name: 'Sankey Chart', category: "Charts", icon: "fa-diagram-sankey" },
		{ id: DisplayTypeId.VegaCharts, name: 'Vega Charts', category: "Charts", icon: "fa-chart-column" },
	]);

	public readonly publish_areas = new StaticData<PublishAreaId, PublishArea>([
		{ id: PublishAreaId.ProgramsAdmissions, name: 'programs-admissions' },
		{ id: PublishAreaId.ProgramsAlumni, name: 'programs-alumni' },
		{ id: PublishAreaId.ProgramsDelivery, name: 'programs-delivery' },
		{ id: PublishAreaId.ProgramsVolunteers, name: 'programs-volunteers' },
	]);

}
